import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const businessCategoryProductSlice = createSlice({
  name: "businessCategoryProduct",

  initialState: {
    businessCategoryProductData: [],
    isError: false,
  },

  reducers: {
    fetchBusinessCategoryProductSuccess: (state, action) => {
      state.isError = false;
      state.businessCategoryProductData = action.payload;
    },
    fetchBusinessCategoryProductFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchBusinessCategoryProductSuccess, fetchBusinessCategoryProductFailure } =
  businessCategoryProductSlice.actions;

export const fetchBusinessCategoryProduct = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/business-category-product-list`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });
    dispatch(fetchBusinessCategoryProductSuccess(response.data.list));
  } catch (error) {
    dispatch(fetchBusinessCategoryProductFailure());
  }
};

export default businessCategoryProductSlice.reducer;